import { render, staticRenderFns } from "./MyAccountSecurityTab.vue?vue&type=template&id=2db415a4"
import script from "./MyAccountSecurityTab.vue?vue&type=script&lang=js"
export * from "./MyAccountSecurityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports